import { LayoutComponent } from "../../../components";
import { Outlet } from "react-router-dom";

export function WelcomeLayout() {
  return (
    <LayoutComponent selectedMenuItem={"welcome"}>
      <Outlet />
    </LayoutComponent>
  );
}
